import { gql } from "apollo-boost"

export const getBudget = gql`
  query Budget($id: ID!) {
    Budget(id: $id) {
      state
      allies
      alliedOne
      alliedTwo
      status
      endDate
      region
      township
      startDate
      concepts {
        id
        isBlocking
        name
        index
        region
        type
        measurementUnit
        unitCost
        totalUnits
        monthlyDistribution
        monthlyDistributionHours
        budgeted
        hours
        investmentDistribution {
          id
          name
          type
          percentage
        }
        humanResource {
          id
          position
          name          
          hours
          contractType          
          benefits                    
          documents {
          id
          name
          url
          type
        }
        positionDocs {
          id
          name
          url
          type
          }
        }
      }
    }
  }
`
